import { UIOption } from 'store/options/interfaces/UIOption';
import palette from '../palette';

declare module '@mui/material/Autocomplete' {
  interface AutocompletePropsSizeOverrides {
    large: true;
  }
}

export default {
  defaultProps: {
    disablePortal: true,
    disableClearable: true,
    blurOnSelect: true,
    getOptionLabel: (option: UIOption | string) =>
      typeof option === 'string' ? option : option.name,
    isOptionEqualToValue: (option: UIOption, value: '' | number) =>
      option.id === value,
  },
  styleOverrides: {
    root: {
      '.MuiOutlinedInput-root': {
        padding: 0,
        // Reserve right-side space for the popup indicator so the input text
        // doesn't slide under the arrow.
        paddingRight: 28,
        background: palette.common?.white,
      },
      // Vertically centre the popup arrow regardless of input size; let MUI's
      // own positioning handle horizontal placement (default `right: 9px`).
      '.MuiAutocomplete-endAdornment': {
        top: '50%',
        transform: 'translateY(-50%)',
        '.MuiIconButton-root': {
          padding: 2,
        },
        '.MuiSvgIcon-root': {
          fontSize: '1.375rem',
        },
      },
      // When both a clear icon and a popup icon render, MUI adds extra padding;
      // override after our own paddingRight so the form layout stays consistent.
      '&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon ': {
        ' .MuiFormControl-root': {
          paddingRight: 0,
        },
      },
    },
    hasPopupIcon: {
      '.MuiFormControl-root.MuiAutocomplete-inputRoot': {
        paddingRight: 28,
      },
    },
  },
};
